import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { deepCopy } from '../../../../../../common/services/common.service';
import { blogPosts } from '../../../../../../redux/blog-posts/action';
import { useSelector } from 'react-redux';
import { selectBlogPostsCreatedItem, selectBlogPostsQueryItem } from '../../../../../../redux/blog-posts/selector';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import PageLoader from '../../../../../../components/PageLoader';
import { blogPostFiles } from '../../../../../../redux/blog-post-files/action';
import { selectBlogPostFilesQueryItem } from '../../../../../../redux/blog-post-files/selector';

import BlogPostComponent from '../components/blog-post.component';
let currentChange: any = {}
const ManagementBlogPost= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const queryItems = useSelector(selectBlogPostsQueryItem)
  const blogPostFilequeryItems = useSelector(selectBlogPostFilesQueryItem)
  	const blogPostCreateItems  = useSelector(selectBlogPostsCreatedItem)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [data, setData] = useState<boolean>(false)
const [
    selectedBlog,
    setSelectedBlog
  ] = useState<any>({})
  const [
    blogPostImageIndex,
    setBlogPostImageIndex
  ] = useState<any>([])

  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchBlogPostById= ()=>{
    dispatch(blogPosts.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-posts/query`,entity:'blogPosts',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
    dispatch(blogPostFiles.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-post-files/query-by-blog-post`,entity:'blogPostFiles',jsonData:{
          
        Records: [
          {
            
              
                  "BlogPostId": parmas?.id
              
          
           
          }
        ]
      
    }}))}).then(()=>{

  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedBlog({ ...selectedBlog, [field]: event });
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchBlogPostById()
        setIsLoading(false)
    }else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedBlog(queryItems?.result?.items)
        const BlogPostItemsData: any = blogPostFilequeryItems?.result?.items?.map((item: any) => {
            const itemData = {
              Id: item?.Id,
              BlogPostId: item?.BlogPostId,
              FileTypeId: item?.FileTypeId,
              FileMappingURL: item?.BlogPostFileURL
            }
            return itemData
          })
          if(BlogPostItemsData){
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: BlogPostItemsData });
        setMediaFiles(localSelectedMedia)
      }}
    },
    [isQuery]
  )

  useEffect(
    () => {
        
      if (data) {
        if(parmas?.id >0){
                  mediaFiles?.splice(
                mediaFiles.length - 1,
                  1
                )
                if(mediaFiles.length>0){
                const BlogPostFileData: any = mediaFiles?.map((item: any) => {
                  const itemData = {
                    Id: item?.Id,
                    BlogPostId: parmas?.id,
                    FileTypeId: item?.FileTypeId,
                    BlogPostFileURL: item?.FileMappingURL
                    }
                  
                  return itemData
                })
                dispatch(blogPostFiles.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-post-files`,entity:'blogPostFiles',jsonData:{
                    
                  Records: [
                    
                      
                    
                      ...BlogPostFileData
                      
                  
                  
                  
                    
                  ]
              
              }}))}
              back()
           }
          else{
            mediaFiles?.splice(
              mediaFiles.length - 1,
                1
              )
              if(mediaFiles.length>0){
              const BlogPostFileData: any = mediaFiles?.map((item: any) => {
                const itemData = {
                  Id: item?.Id,
                  BlogPostId:blogPostCreateItems?.result[0],
                  FileTypeId: item?.FileTypeId,
                  BlogPostFileURL: item?.FileMappingURL
                  }
                
                return itemData
              })
              dispatch(blogPostFiles.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-post-files`,entity:'blogPostFiles',jsonData:{
                  
                Records: [
                  
                    
                  
                    ...BlogPostFileData
                    
                
                
                
                  
                ]
            
            }}))}
            back()
           }
         }
       
    },
    [data]
  )
 
  const deleteSelectedFile = async (Item: any, index: any) => {
    if (Item.Id === 0) {
      mediaFiles?.splice(
        index,
        1
      )
    }
    else {
        dispatch(blogPostFiles.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-post-files/delete`,entity:'blogPostFiles',jsonData:{
        }})).then(()=>{
      mediaFiles?.splice(
        index,
        1
      )
        })}
  }

  const getIsImageRecordDeletable = (idx: any) => {
    if (mediaFiles.length - 1 === idx) {
      return false
    }
    return true
  }
const handleFormSubmit  = async (event: any) => {

    event.preventDefault();
    if (parmas?.id > 0) {
     dispatch(blogPosts.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-posts`,entity:'blogPosts',jsonData:{
          
    Records: [
      {
        
       
         ...selectedBlog
        
    
     
    }
      
    ]
 
}})).then(()=>{
  setData(true)

})
    
    }else{
        dispatch(blogPosts.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/blog/blog-posts`,entity:'blogPosts',jsonData:{
          
            Records: [
              {
                
               
                 ...selectedBlog
                
            
             
            }
              
            ]
    
  }})).then(()=>{
    setData(true)
   
  })
    }

  }

const back=()=>{
  navigate('/management/cms/blog/blog-posts')
} 
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
        Id: 0,
        BlogPostId: parmas?.id,
        FileTypeId: 0,
        FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setBlogPostImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'BlogPost',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[blogPostImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )
  
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         />}
    {isLoading ? <PageLoader /> : 
          <BlogPostComponent
          handleInnerFormChange={handleInnerFormChange}
          handleFormSubmit={handleFormSubmit}
          back={back}
          selectedBlog={selectedBlog}
          mediaFiles={mediaFiles}
          handleFormItemChange={handleFormItemChange}
          changeImage={changeImage}
          getIsImageRecordDeletable={getIsImageRecordDeletable}
          deleteSelectedFile={deleteSelectedFile}
          />
        }
    
          </>
    )
    
    }
   
    export default ManagementBlogPost;
